export default ({ data }) => {
  let {
    qrcodeUrl,
    template,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data || {};

  if (template) {
    template = template.replace("{{qrcodeUrl}}", qrcodeUrl);
    
  }

  return (
    <div>
      {!!template ? (
        <section
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
          }}
          dangerouslySetInnerHTML={{ __html: template }}
        ></section>
      ) : (
        <div>Default WeChat QR Code Block</div>
      )}
    </div>
  );
};
  